import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Anasayfa' },
    { path: '/hakkinda', label: 'Hakkında' },
    { path: '/mimari-yaklasim', label: 'Mimari Yaklaşım' },
    { path: '/projeler', label: 'Seçili Projeler' },
    { path: '/blog', label: 'Blog' },
    { path: '/iletisim', label: 'İletişim' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHomePage
          ? isScrolled
            ? 'bg-white shadow-sm'
            : 'bg-transparent'
          : 'bg-white shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 lg:px-20">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/d670995f71dfffbfea0ee91022b17116.png" 
              alt="Levent Atalay Logo" 
              className="h-10 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-sans tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-dark-gray font-medium'
                    : isHomePage && !isScrolled
                    ? 'text-white hover:text-white/80'
                    : 'text-mid-gray hover:text-dark-gray'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden transition-colors cursor-pointer ${
              isHomePage && !isScrolled ? 'text-white' : 'text-dark-gray'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-8 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-sm font-sans tracking-wide transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-dark-gray font-medium'
                    : 'text-mid-gray hover:text-dark-gray'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
